import { getQueryString } from '../utils';

const search = decodeURIComponent(window.location.search);
const corpId = getQueryString('currentCorpId');

export default {
  confirmNotWifi: 'confirmNotWifi', // 小站打开视频时，如果不是wifi状态则弹出提示，点击确认后存入sessionStorage
  oneMoreTime: 'oneMoreTime',
  loginInfo: 'loginInfo', // 登录信息
  userId: 'userId', // 用户登录的身份标识
  staffId: 'staffId', // 用户登录的身份标识
  userName: 'userName', // 用户姓名
  unionId: 'unionId', // 微信用户登录的unionId
  personnelId: 'personnelId', // 员工id
  appIdConfigData: 'appIdConfigData', // appId，authCorpId，componentAppid参数
  entrySearch: 'entrySearch', // 第一次进入页面需要保存的参数
  entryUrl: 'entryUrl', // 第一次进入页面的url  用于IOS机器签名
  code: 'code', // 最近一次授权存储的code
  snsapiType: 'snsapiType', // 授权类型  snsapi_base  snsapi_userinfo
  needAuthorityRecord: 'needAuthorityRecord', // 是否需要进行授权埋点  1 需要
  closeConsumerTag: 'closeConsumerTag', // 客户标签开关:  1 关闭 0 打开
  quickReplayObj: `quickReplayObj_${corpId}`, // 侧边栏-快捷回复，记录浏览位置
  fileLibraryObj: 'fileLibraryObj', // 侧边栏-文件库，记录浏览位置
  closeContact: 'closeContact', // 管理者小结 - 客户联系开关： 1 关闭 0 打开
  newsLibraryObj: 'newsLibraryObj', // 侧边栏-文件库，记录浏览位置
  businessMaintenanceObj: 'businessMaintenanceObj', // 侧边栏-热门业务，记录浏览位置
  showPosterGuide: 'showPosterGuide', // 营销宝-获客海报，记录第一次访问显示指引
  personalPoster: 'personalPoster', // 获客海报
  articleLibary: 'articleLibary', // 文章库
  currentShareObj: 'currentShareObj', // 当前页面的分享数据
  springFestivalFlag: 'springFestivalFlag',
  isWxActSilentAuthorization: 'isWxActSilentAuthorization', // 表示之前在微信活动页面走过静默授权
  addressComponents: 'addressComponents', // 当前定位到的省市区对象
  isClickToReLocation: 'isClickToReLocation', // LBS【加好友方案】：地理位置授权失败页-用来记录是否用户手动点击 重新授权 地理位置（用户之前拒绝了授权或者授权失败的情况）
  currentCorpId: 'currentCorpId', // 三方应用登录时 保存currentCorpId
  agentId: 'agentId', // 三方应用登录时 保存agentId
  suiteId: 'suiteId', // 三方应用登录时 suiteId
  isShowSwitchBank: 'isShowSwitchBank', // 江阴等银行在分享时需要展示开关
  cardIsShow: 'cardIsShow', // 江阴等银行在分享时需要展示开关状态
  cmtCurrentRoleInfo: 'cmtCurrentRoleInfo', // 社群-当前选择的角色信息
  cmtCurrentHomeDeptInfo: 'cmtCurrentHomeDeptInfo', // 社群-当前选择的部门信息
  wxSchemeSessionId: 'wxSchemeSessionId', // 社群lbs 微信短链
  hadRetriedAutoRefresh: 'hadRetriedAutoRefresh', // session 登录态失效,是否自动重试过刷新
  fromGroup: 'fromGroup', // 表示产品、文章、活动详情页是否从气泡群发进来，因跨应用，故存于sessionStorage
} as { [key: string]: string };
